// Longitude at the equator is 111,320 m per degree. Latitude is 110,540 m per
// degree. The WGS84 ellipsoid helper is a separate radius and is not this pair.

export const METRES_PER_DEGREE_LAT = 110_540;
export const METRES_PER_DEGREE_LNG = 111_320;

export function metresPerDegree(latDeg: number): { kx: number; ky: number } {
  return {
    kx: METRES_PER_DEGREE_LNG * Math.cos((latDeg * Math.PI) / 180),
    ky: METRES_PER_DEGREE_LAT,
  };
}
